export default "__VITE_ASSET__71db5f68__"